import getAxiosAuthHeaders from '../../../functions/getAxiosAuthHeaders';
import api from '../../../apis/api';

const deleteJob = async (id) => {
  return api.delete(`job/${id}`, {
    headers: await getAxiosAuthHeaders(),
  });
};

export default deleteJob;
